<template>
  <div :class="[options.textSizeClass]">
    کد ملی: {{ nationalCode }}
  </div>
</template>

<script>
  import { get } from 'vuex-pathify'

  export default {
    name: 'DefaultAccount',
    props: {
      options: {
        type: Object,
        default: () => { return { textSizeClass: 'text-h6' } },
      },
    },
    data: () => ({}),
    computed: {
      ...get('auth', [
        'getCurrentUser',
      ]),
      nationalCode() {
        var user = this.getCurrentUser
        if (user && user.userData) { return `${user.userData.nationalCode}` }
        return ''
      },
    },
  }
</script>
